import React, { useState, useEffect,useCallback } from "react";
import CoachLayout from "./common/CoachLayout";
import { CoachHeader } from "./common/CoachHeader";
import { useCoachAuthContext } from "./login/useCoachAuthContext";
import API_URL from '../api/API';

export const CoachEditProfile = () => {
  const { coach } = useCoachAuthContext();
  const {dispatch} = useCoachAuthContext();

  const [photoPreview, setPhotoPreview] = useState(null); // To store the preview URL
  const dobOptions = ["1980", "1981", "1982","1983","1984","1985","1986","1987","1988","1989","1990", "1991","1992","1993","1994","1995","1996","1997","1998","1999","2000","2001","2002","2003","2004","2005","2006","2007","2008","2009","2010"];


  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    phonenumber: "",
    email: "",
    password: "",
    city: "",
    state: "",
    dob: "",
    gender: "",
    organization:"",
    sport: "",
    number_of_atheletes: "",
  });

  const [photo, setPhoto] = useState(null);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading,setLoading] = useState(false);
  const [isSaved, setIsSaved] = useState(false);


  // Refactor fetchCoachData to useCallback for reuse
  const fetchCoachData = useCallback(async () => {
    if (coach.email) {
      try {
        const response = await fetch(API_URL.GET_COACH_BY_EMAIL + '/' + coach.email, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${coach.token}`,
          },
        });
        const data = await response.json();
        if (response.ok) {
          setFormData({ ...data });
          setPhotoPreview(API_URL.PROFILE_PICTURE_URL + data.photo);


            // Dispatch action to update the photo
            dispatch({ type: "UPDATE_ACCOUNT_PHOTO", payload: data.photo });

            // Update localStorage as well
            const updatedCoach = { ...coach, photo: data.photo };
            localStorage.setItem("coach", JSON.stringify(updatedCoach));

        } else {
          setError(data.error || "Failed to fetch coach data");
        }
      } catch (err) {
        setError(err.message);
      }
    }
  }, [coach.email, coach.token]);

  useEffect(() => {
    fetchCoachData();
  }, [isSaved]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePhotoChange = (e) => {
    if (e.target.files.length > 0) {

      setPhoto(e.target.files[0]);
       // Create a temporary URL for the selected file
       const previewUrl = URL.createObjectURL(e.target.files[0]);
       setPhotoPreview(previewUrl);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true); 

    try {
      const formPayload = new FormData();
      Object.keys(formData).forEach((key) => {
        formPayload.append(key, formData[key]);
      });
      if (photo) {
        formPayload.append("photo", photo);
      }

      const response = await fetch(API_URL.PATCH_COACH_BY_EMAIL + '/' + coach.email, {
        method: "PATCH",
        body: formPayload,
        headers: {
            Authorization: `Bearer ${coach.token}`,
        },
      });

      const data = await response.json();
      setLoading(false);

      if (!response.ok) {
        setIsSaved(true);
        setError(data.error || "Failed to update profile");
      }else{
        setSuccess("Profile updated successfully!");
        setIsSaved(true);
      }
    
        // Re-fetch the latest data
        //await fetchAthleteData();
    } catch (err) {
      setLoading(false);
      setIsSaved(true);
      setError(err.message);
    }
  };

  useEffect(() => {
    if (isSaved) {
       // console.log("Scroll effect called");
      // Adding a slight delay ensures that the scroll happens after the component has re-rendered
      setTimeout(() => {
        window.scroll({ top: 0, behavior: 'smooth' });
        setIsSaved(false); // Reset the save status after scrolling
      }, 100); // Adjust the delay time if necessary
    }
  }, [isSaved]);


  return (
    <CoachLayout>
      <div className="bg-white">
        <CoachHeader />
        <div className="container mx-auto p-6">
          <h2 className="text-2xl font-bold mb-4">Edit Profile</h2>

         
          <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="col-span-1 md:col-span-2">
              <h3 className="text-xl font-semibold mb-2">Personal Information</h3>
            </div>
            <label>
              <span className="block font-medium mb-1">First Name</span>
              <input
                type="text"
                name="firstname"
                value={formData.firstname}
                onChange={handleChange}
                className="border p-2 rounded w-full"
                placeholder="Enter your first name"
                required
              />
            </label>
            <label>
              <span className="block font-medium mb-1">Last Name</span>
              <input
                type="text"
                name="lastname"
                value={formData.lastname}
                onChange={handleChange}
                className="border p-2 rounded w-full"
                placeholder="Enter your last name"
                required
              />
            </label>
            <label>
              <span className="block font-medium mb-1">Phone Number</span>
              <input
                type="text"
                name="phonenumber"
                value={formData.phonenumber}
                onChange={handleChange}
                className="border p-2 rounded w-full"
                placeholder="Enter your phone number"
                required
              />
            </label>
            <label>
              <span className="block font-medium mb-1">Email</span>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="border p-2 rounded w-full"
                placeholder="Enter your email"
                required
                readOnly
              />
            </label>
            <label>
              <span className="block font-medium mb-1">Password</span>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="border p-2 rounded w-full"
                placeholder="Enter a new password"
                required
              />
            </label>
            <div className="col-span-1 md:col-span-2">
              <h3 className="text-xl font-semibold mb-2">Training Preferences</h3>
            </div>
          
            <label>
              <span className="block font-medium mb-1">Sport</span>

              <select
                name="sport"
                value={formData.sport}
                onChange={handleChange}
                className="border p-2 rounded w-full"
                required
              >
                <option value="">Sport</option>
                <option value="Football">Football</option>
                <option value="Baseball">Baseball</option>
              </select>

            </label>
            <label>
              <span className="block font-medium mb-1">City</span>
              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                className="border p-2 rounded w-full"
                placeholder="Enter your city"
                required
              />
            </label>
            <label>
              <span className="block font-medium mb-1">State</span>
              <input
                type="text"
                name="state"
                value={formData.state}
                onChange={handleChange}
                className="border p-2 rounded w-full"
                placeholder="Enter your state"
                required
              />
            </label>
            <label>
              <span className="block font-medium mb-1">Year of Birth</span>
              <select
                name="dob"
                value={formData.dob}
                onChange={handleChange}
                className="border p-2 rounded w-full"
                required
              >
                <option value="">Select Year Of Birth</option>
                {dobOptions.map((option) => (
                   <option value={option}>{option}</option> 
                ))}
              </select>

            </label>
            <label>
              <span className="block font-medium mb-1">Gender</span>
              <select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                className="border p-2 rounded w-full"
                required
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </label>
            <div className="col-span-1 md:col-span-2">
              <h3 className="text-xl font-semibold mb-2">Organization Details</h3>
            </div>
            <label>
              <span className="block font-medium mb-1">Organization</span>
              <input
                type="text"
                name="organization"
                value={formData.organization}
                onChange={handleChange}
                className="border p-2 rounded w-full"
                placeholder="Organization"
                required
              />
            </label>
            <label>
              <span className="block font-medium mb-1">Number Of Athletes</span>
              <input
                type="text"
                name="number_of_atheletes"
                value={formData.number_of_atheletes}
                onChange={handleChange}
                className="border p-2 rounded w-full"
                placeholder="Number Of Athletes"
                required
              />
            </label>
           
            <div className="col-span-1 md:col-span-2">
              <label>
                <span className="block font-medium mb-1">Profile Photo</span>
                <input
                  type="file"
                  onChange={handlePhotoChange}
                  className="border p-2 rounded w-full"
                  accept="image/*"
                />
              </label>
            </div>
            {/* Preview Section */}
            {photoPreview && (
                <div className="mt-4">
                <p className="text-sm font-medium mb-2">Photo Preview:</p>
                <img
                    src={photoPreview}
                    alt="Profile Preview"
                    className="rounded shadow-md max-w-full h-auto"
                    style={{ width: '30%', borderRadius: '8px', border: '1px solid #ccc' }} 
                />
                </div>
            )}

              

            <div className="col-span-1 md:col-span-2">

            {error && <p className="text-red-500 mb-4">{error}</p>}
          {success && <p className="text-green-500 mb-4">{success}</p>}
 

              {/* Display Loading Indicator */}
                {loading && (
                <p className="text-yellow-500 text-sm mt-2">
                  Processing request please wait...
                </p>
              )}
              <button
                type="submit"
                className="bg-gray-800 text-white py-2 px-4 rounded hover:bg-gray-600 transition mt-2">
                Update Profile
              </button>
            </div>
          </form>
        </div>
      </div>
    </CoachLayout>
  );
};

